import { AuthenticationHandler, AuthenticationMode, AuthenticationConfig } from './types';
import WebAuthHandler from './WebAuthHandler';
import LegacyAppAuthHandler from './LegacyAppAuthHandler';
import ReactNativeAppAuthHandler from './ReactNativeAppAuthHandler';
import { isNativeApp } from '../../../utils/wrapperAppFunctions';

class AuthHandlerFactory {
  static createAuthHandler(config: AuthenticationConfig): AuthenticationHandler {
    const mode = AuthHandlerFactory.detectAuthenticationMode();

    switch (mode) {
      case AuthenticationMode.ReactNativeApp:
        return new ReactNativeAppAuthHandler(config);
      case AuthenticationMode.LegacyApp:
        return new LegacyAppAuthHandler(config);
      case AuthenticationMode.Web:
      default:
        return new WebAuthHandler(config);
    }
  }

  private static detectAuthenticationMode(): AuthenticationMode {
    if (AuthHandlerFactory.isReactNativeApp()) {
      return AuthenticationMode.ReactNativeApp;
    }

    if (isNativeApp()) {
      return AuthenticationMode.LegacyApp;
    }

    return AuthenticationMode.Web;
  }

  private static isReactNativeApp(): boolean {
    const isReactNativeWebView = (window as any).ReactNativeWebView !== undefined;

    return isReactNativeWebView;
  }
}

export default AuthHandlerFactory;
